import { auroraBaseColors, auroraDarkThemeColors, auroraLightThemeColors } from './auroraColors'
import { baseColors, ThemeColors } from './colors'

/**
 * Lyra Connect color overrides extending Aurora theme.
 * Only overrides specific tokens that differ from Aurora.
 */
export const connectLightThemeColors: ThemeColors = {
  ...auroraLightThemeColors,

  // Background - Connect uses white background for sidebar/primary areas
  backgroundPrimary: baseColors.white,
  // backgroundSection - neutral light gray for section cards
  backgroundSection: '#F8F8F8',
  // backgroundSecondary - neutral gray for striped table rows and secondary backgrounds
  backgroundSecondary: '#F8F8F8',
  // backgroundHighlightPrimary - used for hover state on section cards
  backgroundHighlightPrimary: '#F3F3F3',
  // backgroundElement - neutral gray for cards on blue backgrounds
  backgroundElement: baseColors.oatmeal_15,

  // textSecondary - Connect uses a darker secondary text color per Figma
  textSecondary: '#464E61',

  // Highlight - amber background for search highlight matches
  backgroundHighlightSecondary: '#f3b962',

  // Badge - cobalt_50 matches the Figma counter badge color (#1F579E)
  backgroundBadge: auroraBaseColors.cobalt_50,

  // Icon/text inactive - unselected side nav items use a muted blue-gray per Figma (#6A7389)
  iconInactive: '#6A7389',
  textInactive: '#6A7389',

  // Border - cool neutral gray per Connect styleguide
  borderDefault: '#F0F0F0',
  borderInput: baseColors.teal_40,

  // Radio - Aurora uses transparent/white tokens designed for gradient backgrounds; override for light bg visibility
  radioBackgroundSelected: auroraBaseColors.cobalt_80,
  radioWithOutlineBorderHovered: auroraBaseColors.cobalt_50,
  borderHover: auroraBaseColors.cobalt_50,

  // Gradient colors for header sections (article pages, etc.)
  backgroundGradientFirst: auroraBaseColors.cobalt_20,
  backgroundGradientSecond: auroraBaseColors.gradient_background_blend,
  // CTA banner light variant background (cobalt_15 = #E7F1FF)
  backgroundGradientThird: auroraBaseColors.cobalt_15,

  // Logo - Connect uses dark navy logo
  icons: {
    ...auroraLightThemeColors.icons,
    lyraLogoPrimaryIcon: {
      fill: auroraBaseColors.cobalt_75,
    },
  },

  // Badge - aurora-aligned success/neutral colors for cooler tone palette
  components: {
    ...auroraLightThemeColors.components,
    badge: {
      ...auroraLightThemeColors.components.badge,
      success: {
        background: baseColors.green_10,
        text: '#3D701A',
      },
      neutral: {
        background: '#F0F0F0',
        text: '#464E61',
      },
    },
    sideNav: {
      itemActive: { background: '#F2F2F2' },
      expandButtonHover: { background: '#F3F3F3' },
      collapsedItemMenu: { background: '#F7F7F7' },
      divider: { background: '#EEEEEE' },
      itemHover: { background: '#F6F6F6' },
      sectionHeading: { text: '#868C9B' },
    },
  },
}

export const connectDarkThemeColors: ThemeColors = {
  ...auroraDarkThemeColors, // TBD
}
